var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 21,
  viewBox: "0 0 28 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "V"
}, /*#__PURE__*/React.createElement("path", {
  id: "Line 4",
  d: "M23 2.00024L6.02944 18.9708",
  stroke: "#585656",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line 6",
  d: "M23 19L6.02944 2.02944",
  stroke: "#585656",
  strokeWidth: 3,
  strokeLinecap: "round"
}))));
export { SvgClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyOCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IlYiPgo8cGF0aCBpZD0iTGluZSA0IiBkPSJNMjMgMi4wMDAyNEw2LjAyOTQ0IDE4Ljk3MDgiIHN0cm9rZT0iIzU4NTY1NiIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggaWQ9IkxpbmUgNiIgZD0iTTIzIDE5TDYuMDI5NDQgMi4wMjk0NCIgc3Ryb2tlPSIjNTg1NjU2IiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L2c+Cjwvc3ZnPgo=";